module.exports = __webpack_public_path__ + "static/media/CACAO_00.8066bed5.png";